import { EmployeeWebDetail } from 'types/employeeWeb';
import { portalAPI } from './portalAPI';

const APIEmployeeWebSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['EmployeeWeb'] }).injectEndpoints({
    endpoints: (builder) => ({
        getEmployeeWeb: builder.query<EmployeeWebDetail, string>({
            query: (employeeId) => `/v1/employees/${employeeId}/web`,
            providesTags: (_1, _2, employeeId) => [{ type: 'EmployeeWeb', id: employeeId }],
        }),
        updateEmployeeWebPicture: builder.mutation<EmployeeWebDetail, { employeeId: string; pictureBase64: string }>({
            query: ({ employeeId, pictureBase64 }) => ({
                url: `/v1/employees/${employeeId}/web/picture`,
                method: 'PUT',
                body: { pictureBase64 },
            }),
            invalidatesTags: (_1, _2, { employeeId }) => [{ type: 'EmployeeWeb', id: employeeId }],
        }),
        deleteEmployeeWebPicture: builder.mutation<EmployeeWebDetail, string>({
            query: (employeeId) => ({
                url: `/v1/employees/${employeeId}/web/picture`,
                method: 'DELETE',
            }),
            invalidatesTags: (_1, _2, employeeId) => [{ type: 'EmployeeWeb', id: employeeId }],
        }),
    }),
    overrideExisting: false,
});

export const { useGetEmployeeWebQuery, useUpdateEmployeeWebPictureMutation, useDeleteEmployeeWebPictureMutation } =
    APIEmployeeWebSlice;
